import { gql } from "@apollo/client";

const GET_REMITO_BNP_DETALLE = gql`
    query remitoBNPDetalle($idRemito: Int!) {
        remitoBNPDetalle(idRemito: $idRemito) {
            success,
            error,
            valorEsperado {
              idRemito
              codigo
              descripcion
              cantidad
              volumenBolsa
            }
        }
    }
`;

export default GET_REMITO_BNP_DETALLE;

export const adaptRemitoBNPDetalle = (remito) => {
  return {
    idRemito: remito?.idRemito,
    codigo: remito?.codigo,
    descripcion: remito?.descripcion,
    cantidad: remito?.cantidad,
    volumenBolsa: remito?.volumenBolsa
  };
};

export const adaptRemitoBNPDetalleArray = (remitos) => {
  return structuredClone(remitos)?.
  map((remito) => adaptRemitoBNPDetalle(remito));
};